import React from 'react';

import { Cases, PageTitle } from '../../../components';



const CasePage = () => {
 
  return ( 
    <>  
      {/* Page Title */}
      <PageTitle title={'Case Studies'} page={'Case Studies'} />

      {/* Case Studies Section */}
      <section>
        <Cases />
      </section>
    </>
  );
  
}

export default CasePage;